var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.rmcProduceFarmId === "0" &&
              (!_vm.detailForm.auditStatus ||
                _vm.detailForm.auditStatus === "Draft") &&
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_SAVE,
                          expression: "RMC_PROD_FARM_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onAddSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.rmcProduceFarmId !== "0" &&
              (!_vm.detailForm.auditStatus ||
                _vm.detailForm.auditStatus === "Draft") &&
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_SAVE,
                          expression: "RMC_PROD_FARM_SAVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onEditSave },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus !== "PendingApproval" &&
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_SPONS_SUPP") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_SUBMIT,
                          expression: "RMC_PROD_FARM_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onSubmit },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus === "PendingApproval" &&
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_APPROVE,
                          expression: "RMC_PROD_FARM_APPROVE",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onApprove },
                    },
                    [_vm._v("批准")]
                  )
                : _vm._e(),
              _vm.detailForm.auditStatus === "PendingApproval" &&
              _vm.ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") !== -1
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROD_FARM_RETURN,
                          expression: "RMC_PROD_FARM_RETURN",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onReturn },
                    },
                    [_vm._v("退回")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: { model: _vm.detailForm, "label-width": "120px" },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("农场清单")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Category3",
                                  prop: "category3Code",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDisabled || _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.category3Code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "category3Code",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.category3Code",
                                    },
                                  },
                                  _vm._l(
                                    _vm.category3CodeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Sponsor",
                                  prop: "sponsorName",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sponsorName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "sponsorName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.sponsorName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "Farm Group",
                                  prop: "farmGroupId",
                                  rules: _vm.rules.farmGroupId,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.farmGroupId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "farmGroupId",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.farmGroupId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.farmGroupOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.farmGroup,
                                          value: item.rmcProduceFarmGroupId,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "auditStatus" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.auditStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "auditStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.auditStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.auditStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "农场",
                                  prop: "farmName",
                                  rules: _vm.rules.farmName,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.farmName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "farmName", $$v)
                                    },
                                    expression: "detailForm.farmName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "品类",
                                  prop: "varieties",
                                  rules: _vm.rules.varieties,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "multiple_sel",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      multiple: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.varieties,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "varieties",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.varieties",
                                    },
                                  },
                                  _vm._l(
                                    _vm.varietiesOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "农场地址",
                                  prop: "farmAddress",
                                  rules: _vm.rules.farmAddress,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.farmAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "farmAddress",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.farmAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "农场规模(亩)",
                                  prop: "plantingScale",
                                  rules: _vm.rules.plantingScale,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.plantingScale,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "plantingScale",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.plantingScale",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "作物",
                                  prop: "crop",
                                  rules: _vm.rules.crop,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "multiple_sel",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      multiple: "",
                                      placeholder: "请选择",
                                    },
                                    on: { change: _vm.cropChange },
                                    model: {
                                      value: _vm.detailForm.crop,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.detailForm, "crop", $$v)
                                      },
                                      expression: "detailForm.crop",
                                    },
                                  },
                                  _vm._l(
                                    _vm.cropOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.chineseValue,
                                          value: item.code,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "种植方式",
                                  prop: "plantingMode",
                                  rules: _vm.rules.plantingMode,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "multiple_sel",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      clearable: "",
                                      multiple: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.plantingMode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "plantingMode",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.plantingMode",
                                    },
                                  },
                                  _vm._l(
                                    _vm.plantingModeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "农场状态",
                                  prop: "farmStatus",
                                  rules: _vm.rules.farmStatus,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: _vm.isForbidden,
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.farmStatus,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "farmStatus",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.farmStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.farmStatusOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "定植期",
                                  prop: "plantingPeriod",
                                  rules: _vm.rules.plantingPeriod,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.plantingPeriod,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "plantingPeriod",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.plantingPeriod",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "采购期",
                                  prop: "harvestTime",
                                  rules: _vm.rules.harvestTime,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.harvestTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "harvestTime",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.harvestTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "联系人",
                                  prop: "farmContacts",
                                  rules: _vm.rules.farmContacts,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.farmContacts,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "farmContacts",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.farmContacts",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "联系电话",
                                  prop: "contactInformation",
                                  rules: _vm.rules.contactInformation,
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.contactInformation,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "contactInformation",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.contactInformation",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "其他", prop: "comments" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.detailForm.comments,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "comments", $$v)
                                    },
                                    expression: "detailForm.comments",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.$route.query.from === "edit"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "is-required",
                                    attrs: {
                                      label: "上次修改原因",
                                      prop: "lastUpdateReason",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled: "",
                                        type: "textarea",
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        autosize: { minRows: 4, maxRows: 6 },
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.lastUpdateReason,
                                        callback: function ($$v) {
                                          _vm.lastUpdateReason = $$v
                                        },
                                        expression: "lastUpdateReason",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "修改原因",
                                  prop: "updateReason",
                                  rules: _vm.rules.updateReason,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isForbidden,
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.updateReason,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "updateReason",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.updateReason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            title: "退回意见",
            visible: _vm.dialogReturnVisible,
            width: "30%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReturnVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "returnForm",
              attrs: { model: _vm.returnForm, rules: _vm.returnFormRules },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "returnedReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "1000",
                      "show-word-limit": "",
                      autosize: { minRows: 4, maxRows: 6 },
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.returnForm.returnedReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.returnForm, "returnedReason", $$v)
                      },
                      expression: "returnForm.returnedReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.onClose } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }